<template>
  <v-form v-model="valid" ref="formData" lazy-validation>
    <v-dialog v-model="dialog" persistent fullscreen>
      <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
      <v-card v-if="datas">
        <v-card-title class="dialog-header">
          <span class="headline">{{ $t("requestDrawDownCreditLine") }}</span>
          <v-spacer></v-spacer>
          <v-btn fab text icon @click="handleClose()" v-shortkey="['esc']" @shortkey.native="handleClose()"><font-awesome-icon class="close-dialog" icon="times"/></v-btn>
        </v-card-title>

        <v-card-title class="mt-5" v-if="datas.status === 'pending'">
          <v-spacer></v-spacer>
          <v-btn rounded class="mr-1" depressed color="primary" @click="handleDialog('review')">{{ $t("review") }}</v-btn>
          <v-btn rounded depressed color="error" @click="handleDialog('reject')">{{ $t("reject") }}</v-btn>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col :cols="component === 'crop' ? '12' : ''">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" style="float: left;">
                      <table v-if="component === 'revolving'">
                        <tr>
                          <th>{{ $t('loanReference') }}</th>
                          <td>: {{ datas.application }} </td>
                        </tr>

                        <tr>
                          <th>{{ $t('paddy_type') }}</th>
                          <td>: {{ datas.crop_type_name }} </td>
                        </tr>

                        <tr>
                          <th>{{ $t('qty') }}</th>
                          <td>: {{ datas.quantity | formatNumber}} KG </td>
                        </tr>

                        <tr>
                          <th>{{ $t('costUnit') }}</th>
                          <td>: {{ datas.farmer_price | formatNumber }} {{datas.currency_code}} / KG</td>
                        </tr>

                        <tr>
                          <th>{{ $t('amount') }}</th>
                          <td>: {{ (datas.quantity *datas.farmer_price) | formatNumber }} {{ datas.currency_code }}</td>
                        </tr>

                        <tr>
                          <th>{{ $t('requestDrawDownAmount') }}</th>
                          <td>: {{ datas.drawdown_amount | formatNumber }} {{ datas.currency_code }}</td>
                        </tr>

                      </table>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" style="float: left;">
                      <table>
                        <tr>
                          <th style="border-bottom: black 1px solid;">{{ $t('sell_to_miller') }}</th>
                          <th style="border-bottom: black 1px solid;"></th>
                        </tr>
                        <tr>
                          <th>{{ $t('miller') }}</th>
                          <td>: {{ datas.miller_name }}</td>
                        </tr>
                        <tr>
                          <th>{{ $t('provinceArea') }}</th>
                          <td>: {{ datas.unload_area }}</td>
                        </tr>
                        <tr>
                          <th>{{ $t('priceUnit') }}</th>
                          <td>: {{ datas.miller_price | formatNumber }} {{datas.currency_code}}</td>
                        </tr>
                        <tr>
                          <th>{{ $t('miller_payment_date') }}</th>
                          <td>: {{ datas.miller_payment_date }}</td>
                        </tr>

                      </table>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" style="float: left;">
                      <table>
                        <tr>
                          <th style="border-bottom: black 1px solid;">{{ $t('infoRequestDrawdown') }}</th>
                          <th style="border-bottom: black 1px solid;"></th>
                        </tr>
                        <tr>
                          <th>{{ $t('interestDrawdown') }}</th>
                          <td>: {{ datas.interest_amount | formatNumber }} {{datas.currency_code}}</td>
                        </tr>
                        <tr>
                          <th>{{ $t('feeDrawDown') }}</th>
                          <td>: {{ datas.charge_amount | formatNumber }} {{datas.currency_code}}</td>
                        </tr>
                        <tr>
                          <th>{{ $t('collectDrawDown') }}</th>
                          <td>: {{ datas.receive_amount  | formatNumber }} {{datas.currency_code}}</td>
                        </tr>
                        <tr>
                          <th>{{ $t('requestDrawDownDate') }}</th>
                          <td>: {{ datas.drawdown_date }}</td>
                        </tr>
                        <tr>
                          <th>{{ $t('authorizeDate') }}</th>
                          <td>: {{ datas.authorize_date }}</td>
                        </tr>
                        <tr>
                          <th>{{ $t('RepaymentDate') }}</th>
                          <td>: {{ datas.repayment_date }}</td>
                        </tr>

                      </table>
                    </v-col>
                  </v-row>
                  <div style="clear: both"></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Comfirm -->
      <div class="text-center">
        <v-dialog v-model="isConfirmDialog" width="500">
          <v-card>
            <v-card-text class="text-center" style="padding: 20px 0;">
              <img src="data:image/png;base64,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" alt="">
              <h2 style="margin: 30px 0;">{{ this.requestDrawdownType === 'review' ? $t("doYouWantReviewtransaction") : $t("doYouWantRejecttransaction")}}</h2>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn rounded class="mr-2" depressed color="primary" @click="handleConfirmDialog()">
                <v-progress-circular
                    v-if="requestDrawdownLoading"
                    indeterminate
                    :width="1"
                    :size="20"
                ></v-progress-circular>
                <span v-else>
                    {{ $t("agree") }}
                </span>
              </v-btn>
              <v-btn rounded depressed color="red" @click="isConfirmDialog = false">{{ $t("close") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

    </v-dialog>
  </v-form>

</template>
<script>
import {provider} from "@/service/provider";
import MainMixin from "../../../mixins/mainMixin";
import ValidatorMixin from "../../../mixins/validatorMixin";
import OptionDataMixin from "../../../mixins/optionDataMixin";
import axios from "axios";

export default {
  name: "requestDrawdownDetial",
  mixins: [MainMixin, ValidatorMixin, OptionDataMixin],
  props: ['option'],
  data() {
    return {
      isConfirmDialog: false,
      requestDrawdownLoading: false,
      requestDrawdownType: '',
      component: '',
      datas: {},
    };
  },
  methods: {
    handleClose(){
      this.dialog = false;
      this.$emit('handle-close', false)
    },

    handleDialog(type){
      this.isConfirmDialog = true;
      this.requestDrawdownType = type;
    },

    handleConfirmDialog(){
      this.requestDrawdownLoading = true;
      let query = {request_drawdown_id: [{id: this.datas.id, type: this.requestDrawdownType}]};
      let url = provider.baseURL + provider.reviewRequestDrawdown;
      axios.post(url, query, {headers: {Authorization: localStorage.token}}).then(res => {
        if (res.data.response && res.data.response.code === 200) {
          this.$notify({
            title: "Successful",
            message: this.$t("success"),
            type: "success",
            duration: 2000
          });
          this.dialog = false;
          this.isConfirmDialog = false;
          this.$emit('handle-close', true);
        }else{
          this.$notify({
            title: "Warning",
            message: res.data.response.message,
            type: "warning",
            duration: 2000
          });
        }

      }).catch(error => console.log(error)).then(() => this.requestDrawdownLoading = false)
    }
  },

  mounted(){
    this.dialog = this.option.dialog;
    if(this.option.dialog && this.option.item){
      this.datas = this.option.item;
      this.component = this.option.component;
    }
  }
};
</script>

<style scoped>
table tr th,
table tr td {
  font-size: 16px;
  padding-bottom: 12px;
  text-align: left;
}
</style>